export default function Marquee({ items = [] }) {
  const list = items.length ? items : ["ПВХ-ПАНЕЛИ", "ПРОИЗВОДСТВО", "ОПТ И РОЗНИЦА"];
  const doubled = [...list, ...list];
  return (
    <div className="pp-marquee bg-[#0F1720] text-white overflow-hidden select-none">
      <div className="pp-marquee-track py-2.5">
        {doubled.map((item, i) => (
          <span key={i} className="inline-flex items-center">
            <span className="px-5 text-[11px] font-display font-semibold uppercase tracking-[0.14em] text-slate-300">{item}</span>
            <span className="w-1 h-1 rounded-full bg-[#E85D2A]" />
          </span>
        ))}
      </div>
    </div>
  );
}
